<h1>M&eacute;mos</h1>
<pannel [title]="'Filtres'" [expandable]="true" [folded]="true">
	<memos-filters
		(filterRequest)="onFilterRequest($event)"
		>
	</memos-filters>
</pannel>
<pannel [title]="'M&eacute;mos'">
	<memos-table
		[filtersSubject]="filtersSubject"
		>
	</memos-table>
</pannel>